
import { useState, useEffect } from 'react'
import { firestore } from '../Firebase/Firebase'

const  useFirestore = ( collection, limit ) => {
    const [docs, setDocs] = useState([]);

    useEffect(() => {
      const unsub = firestore.collection(collection)
      .orderBy('Time', 'desc')
      .limit(limit) 
      .onSnapshot((snap) => {
        let documents = [];
        snap.forEach(doc => {
            documents.push({...doc.data(), id: doc.id})
        });
        setDocs(documents)
      });
      return () => unsub();
    }, [collection, limit])

    
  return (
   {docs}
  )
}

export default useFirestore
